var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M425.475 41.375C437.975 28.875 458.275 28.875 470.775 41.375C483.275 53.875 483.275 74.175 470.775 86.675L301.375 255.975L470.675 425.375C483.175 437.875 483.175 458.175 470.675 470.675C458.175 483.175 437.875 483.175 425.375 470.675L256.075 301.275L86.675 470.575C74.175 483.075 53.875 483.075 41.375 470.575C28.875 458.075 28.875 437.775 41.375 425.275L210.775 255.975L41.475 86.575C28.975 74.075 28.975 53.875 41.475 41.375C53.975 28.875 74.275 28.875 86.775 41.375L256.075 210.675L425.475 41.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.8271534f0f93f835d7dddae3ac69c4c9.svg";
export { ForwardRef as ReactComponent };